import { generateRefreshKey, GetVariableValue } from '../hooks'
import {
  BooleanVariable,
  NumberVariable,
  progressActiveAttribute,
  progressTrackAttribute,
  progressPassedAttribute,
} from './index'

const nextEvent = 'nextEvent'
export const progressIndicatorHandler = async (
  id: string,
  progressIndicator: HTMLElement,
  getVariableValue: GetVariableValue,
  value?: NumberVariable,
  duration?: NumberVariable,
  loop?: BooleanVariable,
  indexInList?: number
) => {
  const progressTracks = Array.from(
    progressIndicator.querySelectorAll(`:scope > i > i > i[${progressTrackAttribute}]`)
  ) as SVGRectElement[]
  if (progressTracks.length) {
    let timer: NodeJS.Timeout | null
    const lastIndex = progressTracks.length - 1
    const loopValue = await getVariableValue({ ...loop, booleanConstant: loop?.constant })
    const durationValue = await getVariableValue({ ...duration, numberConstant: duration?.constant })
    progressTracks.forEach((el, i) =>
      // @ts-ignore
      el.addEventListener(nextEvent, ({ detail }) => {
        if (timer) {
          clearTimeout(timer)
        }
        progressTracks.slice(0, i).forEach(el => {
          el.setAttribute(progressPassedAttribute, 'true')
          el.removeAttribute(progressActiveAttribute)
          el.style.minWidth = '0'
          el.style.maxWidth = '100%'
        })
        progressTracks.slice(i + 1).forEach(el => {
          el.removeAttribute(progressPassedAttribute)
          el.removeAttribute(progressActiveAttribute)
          el.style.minWidth = '0'
          el.style.maxWidth = '100%'
        })
        progressTracks[i].removeAttribute(progressPassedAttribute)
        progressTracks[i].setAttribute(progressActiveAttribute, 'true')
        if (detail) {
          const width = `${detail * 100}%`
          progressTracks[i].style.minWidth = width
          if (!durationValue) {
            progressTracks[i].style.maxWidth = width
          }
        }
        const next = () => {
          if (progressTracks[i + 1]) {
            progressTracks[i + 1].dispatchEvent(new Event(nextEvent))
          } else if (loopValue) {
            progressTracks[0].dispatchEvent(new Event(nextEvent))
          }
        }
        if (!document.getElementById(progressIndicator.id)) {
          return
        } else if (durationValue) {
          timer = setTimeout(next, durationValue * 1000)
        }
      })
    )
    const valueRefresh = async () => {
      progressTracks.forEach(el => {
        el.removeAttribute(progressPassedAttribute)
        el.removeAttribute(progressActiveAttribute)
        el.style.minWidth = '0'
        el.style.maxWidth = '100%'
      })
      const valueValue = await getVariableValue(
        { ...value, numberConstant: value?.constant },
        { [generateRefreshKey(id, 'value', indexInList)]: valueRefresh }
      )
      const currentValue = valueValue ? Math.ceil(valueValue) : 0
      const detail = currentValue <= lastIndex + 1 && valueValue ? valueValue % 1 : 0
      progressTracks[(currentValue > lastIndex + 1 ? lastIndex + 1 : currentValue) - 1]?.dispatchEvent(
        new CustomEvent(nextEvent, { detail })
      )
    }
    await valueRefresh()
  }
}
